const unitsByCourse = (
  state = {
    isFetching: false,
    receivedAt: null,
    items: [],
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_UNITS':
      return {
        ...state,
        isFetching: true,
      }
    case 'RECEIVE_UNITS':
      return {
        ...state,
        isFetching: false,
        items: action.units,
        receivedAt: Date.now(),
      }
    default:
      return state
  }
}

const units = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_COURSES':
      return {
        ...state,
        ...action.courses.reduce((accumulator, currentCourse) => {
          return {
            ...accumulator,
            [currentCourse.courseCode]: unitsByCourse(state[currentCourse.courseCode], action),
          }
        }, {})
      }
    case 'REQUEST_UNITS':
    case 'RECEIVE_UNITS':
      return {
        ...state,
        [action.courseId]: unitsByCourse(state[action.courseId], action)
      }
    default:
      return state
  }
}

export default units
